import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'

import styles from './styles.scss'

const DefaultItem = () => <span styleName='valueItem'>Select User</span>

export default CSSModules(styles, DefaultItem)
